import { useQuery } from "@tanstack/react-query";
import { useActualViewer } from "@softmax/web-features/session/records";
import { NavigationReady } from "@softmax/web-features/navigation/markers";
import { PlaySubpage } from "@softmax/product-ux/play";
import { useGameContext } from "@/features/game/state";
import { activityTimeZone, groupByDay } from "./lib/activity/feed-calendar";
import { ActivityFeed } from "./sections/activity-feed";
import { SubpageHeader } from "./sections/subpage-header";
import { playActivityOptions } from "./play.queries";
import { PlayResource } from "./play-resource";
export function PlayActivityPage() {
  const game = useGameContext();
  const viewer = useActualViewer();
  const query = useQuery({
    ...playActivityOptions({
      href: game.publicPath,
      viewerId: viewer.data?.subject_id ?? null,
    }),
    enabled: viewer.isSuccess,
  });
  return (
    <PlayResource query={query} requiresSession>
      {(data) => (
        <PlaySubpage
          header={
            <SubpageHeader
              leagueName={data.league.name}
              route={data.league.route}
              title="Activity"
            />
          }
          summary={`${data.policyName ?? "—"} · ${data.feed.length} event${data.feed.length === 1 ? "" : "s"} in the last 7 days`}
        >
          <NavigationReady stage="content" path={game.publicPath} />
          <ActivityFeed
            groups={groupByDay({
              rows: data.feed,
              now: data.generatedAt,
              timeZone: activityTimeZone,
            })}
            now={data.generatedAt}
            maxRows={Math.max(data.feed.length, 1)}
          />
        </PlaySubpage>
      )}
    </PlayResource>
  );
}
